<!-- 审核管理 -->
<template>
  <div class="audit-management">
    <el-tabs v-model="tabActiveName">
      <el-tab-pane label="节目" name="first"> </el-tab-pane>
      <el-tab-pane label="节目集" name="second"></el-tab-pane>
    </el-tabs>
    <Program v-if="tabActiveName=='first'"/>
    <ProgramCollect v-else/>
  </div>
</template>
<script>
import Program from './components/program.vue'
import ProgramCollect from './components/programCollect.vue'
export default {
  name: 'AuditManagement',
  components: {
    Program,
    ProgramCollect
  },
  data () {
    return {
      tabActiveName: 'first'
    }
  }
}
</script>
